import * as yup from "yup";

declare module "yup" {
   export interface StringSchema {
      /**
      * Check for name validity.
      *       
      * @param {Boolean} [required=false] Is name required.
      * @param {String} [errorMessage=DEFAULT_MESSAGE] The error message to return if the validation fails.
      */
      domainList(
         required: boolean,
         errorMessage?: string
      ): StringSchema;
   }
}
const YUP_NAME_METHOD = "domainList";
const domainRegex = /^((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
yup.addMethod(yup.string, YUP_NAME_METHOD, function yupDomainList(
   required: boolean,
   errorMessage: ""
) {
   const errMsg =
      typeof errorMessage === "string" && errorMessage
         ? errorMessage
         : "Domains should be like \"example.com\" separated by commas";

   return this.test(YUP_NAME_METHOD, errMsg, (value: string) => {
      if (!value) return !required;

      // Split the string by commas
      const domains = value.split(",").map((email) => email.trim());

      // Validate each email using the regex
      return domains.every((domain) => domainRegex.test(domain));
   });
});
